export default __webpack_public_path__ + "static/media/user.eee1bae3.svg";